import React from 'react';
import Const from 'constants';
import {PlayersDashboard as ClassicPlayersDashboard} from './classic';
import {PlayersDashboard as TiersPlayersDashboard} from './tiers';

const PlayersDashboard = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicPlayersDashboard;
        } else if (sportConfig.isGameTypeShowDown()) {
            return ClassicPlayersDashboard;
        } else if (sportConfig.isGameTypeTiers()) {
            return TiersPlayersDashboard;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersDashboard};
